<script lang="ts" setup>
import { version } from "../../../../package.json";
</script>

<template>
  <span class="version" data-test-id="AppVersionComponent">v{{ version }}</span>
</template>

<style scoped>
.version {
  background: white;
  border: 1px solid #dddddd;
  border-radius: 5px;
  bottom: 0.25rem;
  color: #888888;
  font-size: 0.8rem;
  padding: 0 4px;
  position: fixed;
  right: 0.25rem;
}
</style>
